/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create a new available parking
 * @export
 * @interface CreateAvailableParking
 */
export interface CreateAvailableParking {
    /**
     * 
     * @type {string}
     * @memberof CreateAvailableParking
     */
    parking: string;
}

/**
 * Check if a given object implements the CreateAvailableParking interface.
 */
export function instanceOfCreateAvailableParking(value: object): value is CreateAvailableParking {
    if (!('parking' in value) || value['parking'] === undefined) return false;
    return true;
}

export function CreateAvailableParkingFromJSON(json: any): CreateAvailableParking {
    return CreateAvailableParkingFromJSONTyped(json, false);
}

export function CreateAvailableParkingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAvailableParking {
    if (json == null) {
        return json;
    }
    return {
        
        'parking': json['parking'],
    };
}

export function CreateAvailableParkingToJSON(json: any): CreateAvailableParking {
    return CreateAvailableParkingToJSONTyped(json, false);
}

export function CreateAvailableParkingToJSONTyped(value?: CreateAvailableParking | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parking': value['parking'],
    };
}

